import type { Middleware } from "@reduxjs/toolkit";

import { addNotification } from "../slices/uiSlice";

export const errorMiddleware: Middleware = store => next => action => {
  // Type assertion with runtime checks
  const actionObj = action as any;

  // Handle API errors and show notifications
  if (actionObj.type?.endsWith("/rejected") && actionObj.payload) {
    const error = actionObj.payload;

    // Don't show notifications for certain errors
    const skipNotification = ["auth/login/rejected", "auth/register/rejected"].includes(
      actionObj.type
    );

    if (!skipNotification) {
      store.dispatch(
        addNotification({
          type: "error",
          title: "Error",
          message: error.message || "An unexpected error occurred",
          duration: 5000,
        })
      );
    }
  }

  // Handle successful actions
  if (actionObj.type?.endsWith("/fulfilled")) {
    const successMessages: { [key: string]: string } = {
      "booking/createBooking/fulfilled": "Booking created successfully!",
      "event/createEvent/fulfilled": "Event created successfully!",
      "ground/createGround/fulfilled": "Ground created successfully!",
      "auth/updateProfile/fulfilled": "Profile updated successfully!",
    };

    const message = successMessages[actionObj.type];
    if (message) {
      store.dispatch(
        addNotification({
          type: "success",
          title: "Success",
          message,
          duration: 3000,
        })
      );
    }
  }

  return next(actionObj);
};
